
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cluster/detail/[id]/[page]",
      function () {
        return require("private-next-pages/cluster/detail/[id]/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cluster/detail/[id]/[page]"])
      });
    }
  